import React from 'react';
import { ChevronRight, Plus, QrCode } from 'lucide-react';
import { OwnerButton, OwnerShell } from '../OwnerShell';
import { StatusBadge } from '../../common/StatusBadge';
import { useMyVehicles } from '../../../hooks/useMyVehicles';
import { ownerVehicleStatus, stickerStatus } from '../../../utils/ownerStatus';
import type { OwnerNav } from '../../../types/owner';
export function OwnerVehicles({
  nav
}: {
  nav: OwnerNav;
}) {
  const vehicles = useMyVehicles();
  return <OwnerShell nav={nav} title="আমার গাড়িসমূহ" back={false} tabs data-id="element-2159" data-mp="3k9c1p6y199iv">
      <div className="space-y-3" data-id="element-2160" data-mp="3k80xj60odzr8">
        {vehicles.map(({
        vehicle: v,
        app
      }) => {
        const st = ownerVehicleStatus(app.status);
        const qr = app.status === 'বাতিল' ? {
          label: 'প্রযোজ্য নয়',
          tone: 'gray' as const
        } : stickerStatus(app.stage);
        return <button key={v.id} onClick={() => {
          nav.setVehicleId(v.id);
          nav.setDetailTab('info');
          nav.go('vehicleDetail');
        }} className="block w-full overflow-hidden rounded-2xl border border-border bg-white text-left shadow-sm transition hover:border-navy-300" data-id="element-2161" data-mp="35bjm6eshkl4o">
              <div className="relative h-36" data-id="element-2162" data-mp="3hhijcswhw3ou">
                <img src={v.image} alt={`${v.typeLabel} — ${v.reg}`} className="h-full w-full object-cover" data-id="element-2163" data-mp="32r1gr684j7qd" />
                <span className="absolute left-3 top-3 rounded-full bg-white/95 px-2.5 py-0.5 text-[11px] font-semibold text-navy-900" data-id="element-2164" data-mp="37qnwpnfc722v">{v.typeLabel}</span>
              </div>
              <div className="p-3.5" data-id="element-2165" data-mp="48nj9sr0i4hv">
                <div className="flex items-center justify-between gap-2" data-id="element-2166" data-mp="47kwnx0q2o7r">
                  <p className="font-heading text-base font-bold text-navy-900" data-id="element-2167" data-mp="3mfaa3jleljrg">{v.reg}</p>
                  <ChevronRight className="h-4 w-4 text-slate-400" data-id="element-2168" data-mp="3qfkqlq6tnskk" />
                </div>
                <p className="text-[11.5px] text-slate-500" data-id="element-2169" data-mp="2azllknsi4coj">{v.brand} {v.model} • {v.color}</p>
                <div className="mt-2.5 grid grid-cols-2 gap-2 border-t border-slate-100 pt-2.5 text-[11px]" data-id="element-2170" data-mp="2f0p2ldmacerc">
                  <div data-id="element-2171" data-mp="lirguvwbrcv0">
                    <p className="mb-0.5 text-slate-400" data-id="element-2172" data-mp="lh6mp7dx9vxo">অবস্থা</p>
                    <StatusBadge tone={st.tone} className="!text-[10.5px]" data-id="element-2173" data-mp="gjewqiwu8jw4">{st.label}</StatusBadge>
                  </div>
                  <div data-id="element-2174" data-mp="brn5s79rsc5g">
                    <p className="mb-0.5 flex items-center gap-1 text-slate-400" data-id="element-2175" data-mp="bqu61q98amwt"><QrCode className="h-3 w-3" data-id="element-2176" data-mp="6tvdvd94kq19" />QR স্টিকার</p>
                    <StatusBadge tone={qr.tone} className="!text-[10.5px]" data-id="element-2177" data-mp="6rhit4eg3dtp">{qr.label}</StatusBadge>
                  </div>
                </div>
              </div>
            </button>;
      })}
        <OwnerButton variant="green" onClick={() => nav.go('addVehicle')} data-id="element-2178" data-mp="3u0e56td09eln"><Plus className="h-5 w-5" data-id="element-2179" data-mp="3ozgq4pnal0od" />নতুন গাড়ি যুক্ত করুন</OwnerButton>
      </div>
    </OwnerShell>;
}